<template>
  <page-edicion fluid>
    <page-header :title="oferta.descripcion" @back="volver" subtitle="Contenido de módulos" />
    <b-form @submit.prevent="guardar">
      <b-tabs small card pills vertical>
        <b-tab v-for="modulo in modulos" :key="modulo.id" :title="modulo.nombre">
          <b-form-group label="Descripción corta">
            <wysiwyg v-model="modulo.contenido.descCorta" placeholder="Escriba aquí" />
          </b-form-group>
          <b-form-group label="Descripción larga">
            <wysiwyg v-model="modulo.contenido.descLarga" placeholder="Escriba aquí" />
          </b-form-group>
          <b-form-group label="Necesidad">
            <wysiwyg v-model="modulo.contenido.necesidad" placeholder="Escriba aquí" />
          </b-form-group>
          <b-form-group label="Solución">
            <wysiwyg v-model="modulo.contenido.solucion" placeholder="Escriba aquí" />
          </b-form-group>

          <b-button @click="restablecer(modulo.moduloId)">
            Restablecer contenidos a partir del módulo original
          </b-button>
        </b-tab>
      </b-tabs>
      <botonera-edicion @cancelar="volver" />
    </b-form>
  </page-edicion>
</template>

<script>
import * as ofertasApi from "@/services/ofertas";
import * as modulosApi from "@/services/modulos.js";

export default {
  components: {},
  data() {
    return {
      oferta: {
        descripcion: "",
      },
      modulos: [],
    };
  },
  async mounted() {
    var data = await ofertasApi.cargarCompleta(this.$route.params.id);
    this.oferta = data.oferta;
    this.modulos = data.ofertaModulos.map((m) => {
      m.opened = false;
      m.contenido = data.ofertaModulosContenido.find((c) => c.ofertaModuloId == m.id);
      return m;
    });
  },
  methods: {
    async guardar() {
      var modulos = this.modulos.map((m) => m.contenido);
      await ofertasApi.guardarContenidoModulos(this.oferta.id, modulos);
      this.$router.push("/ofertas");
    },
    async restablecer(moduloId) {
      var contenido = await modulosApi.cargarContenido(moduloId);
      var modulo = this.modulos.find((m) => m.moduloId == moduloId);
      modulo.contenido.descCorta = contenido.descCorta;
      modulo.contenido.descLarga = contenido.descLarga;
      modulo.contenido.necesidad = contenido.necesidad;
      modulo.contenido.solucion = contenido.solucion;
    },
  },
};
</script>
